module.exports = __webpack_public_path__ + "static/media/slide-2.d68e0439.png";